import { css, cx } from '@linaria/atomic';
import { TextLink } from '../../text-link/text-link.component';

const clearButtonStyle = css`
  position: absolute;
  left: 0;
`;

export type StepperClearButtonProps = {
  clearStep: () => void;
  trackingId?: string;
  children: string;
  className?: string;
};

export const StepperClearButton = ({
  clearStep,
  trackingId = '',
  children = 'Clear',
  className,
  ...rest
}: Partial<StepperClearButtonProps>) => {
  return (
    <TextLink
      className={cx('step-button clear-step', clearButtonStyle, className)}
      trackingId={trackingId}
      onClick={() => clearStep?.()}
      {...rest}
    >
      {children}
    </TextLink>
  );
};
